/**
 * @description useRedux 封装hooks版本的redux
 * @author liushuai
 */
import React, { createContext, useContext, useReducer } from 'react';
export interface IState {
    [propName: string]: any;
}
export interface IStore {
    _state: IState;
    dispatch: any;
    getState: () => IState;
    _useContext: () => any;
}
function middlewareLog(store: IStore, lastState: IState, nextState: IState, action: any) {
    console.log('🏮 store', store);
    console.log(action.type);
    console.log('🐷last--->', lastState);
    console.log('🐶next--->', nextState);
}

function reducerInAction(state: IState, action: any) {
    if (typeof action.reducer === 'function') {
        return action.reducer(state);
    }
    return state;
}

export const createStore = (params: IState) => {
    const { reducer, initialState, middleware } = {
        initialState: {},
        reducer: reducerInAction,
        middleware: [middlewareLog],
        ...params,
    };

    const AppContext = createContext({});
    const _useContext = () => {
        return useContext(AppContext);
    };
    const store: IStore = {
        _state: initialState,
        dispatch: undefined,
        getState: () => {
            return store._state;
        },
        _useContext,
    };

    let isCheckedMiddleware = false;

    const middlewareReduer = (lastState: IState, action: any) => {
        let nextState = reducer(lastState, action);
        if (!isCheckedMiddleware) {
            if (!Array.isArray(middleware)) {
                throw new Error('react-hooks middleware必须是数组');
            }
            isCheckedMiddleware = true;
        }
        for (const item of middleware) {
            const newState: any = item(store, lastState, nextState, action);
            if (newState) {
                nextState = newState;
            }
        }
        // 记得把这个修改后的装填到store
        store._state = nextState;
        return nextState;
    };

    const Provider = (props: IState) => {
        const [state, dispatch] = useReducer(middlewareReduer, initialState);
        if (!store.dispatch) {
            store.dispatch = async (action: any) => {
                if (typeof action === 'function') {
                    await action(dispatch, store._state);
                } else {
                    dispatch(action);
                }
            };
        }
        return <AppContext.Provider {...props} value={state} />;
    };

    return {
        Provider,
        store,
    };
};
